import AppUserMain from './UsersMain'
import AppUsersList from './UsersList'
import AppUsersAddEdit from './UsersAddEdit'
import AppUsersEmailsList from './UsersEmailsList'
import AppUsersEmailNewInfo from './UsersEmailsNewInfo'

export default [
  {
    path: '/users',
    component: AppUserMain,
    children: [
      { name: 'AppUsersList', path: '', component: AppUsersList },
      { name: 'AppUsersAdd', path: 'add', component: AppUsersAddEdit },
      { name: 'AppUsersEdit', path: 'edit/:codUser', component: AppUsersAddEdit },
      { name: 'AppUsersEmailsList', path: ':codUser/emails', component: AppUsersEmailsList },
      { name: 'AppUsersEmailNew', path: ':codUser/emails/new', component: AppUsersEmailNewInfo }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/users/users.routes.js